<script setup lang="ts">
import { onBeforeMount } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { isUrlAllowed } from '@/utils/check-url-allow';

const route = useRoute();
const router = useRouter();

onBeforeMount(() => {
  const { cb = '' } = route.query;

  // 参数为空，返回首页
  if (!cb) {
    router.push('/');
    return;
  }

  const targetUrl = cb.toString();

  // 安全校验：验证 URL 格式和白名单域名
  if (!isUrlAllowed(targetUrl)) {
    console.error('[安全拦截] 不允许跳转到该 URL:', targetUrl);
    router.push('/');
    return;
  }

  // 中间页，用于端内新标签页打开地址
  window.location.href = targetUrl;
});
</script>
